import type React from 'react';

import { parseHtml } from '@change-corgi/core-react/html';

export const EmailPreview: React.FC<{ blurb: string }> = ({ blurb }) => {
	return (
		<div className="admin:flex admin:flex-col admin:gap-2 admin:[&_ul]:mx-4 admin:[&_ul]:list-disc admin:[&_ol]:mx-4 admin:[&_ol]:list-decimal admin:[&_li]:mx-1 admin:[&_li]:my-2">
			{parseHtml(blurb)}
		</div>
	);
};
